import { Controller } from 'stimulus'
import { updateCartAndPrices } from '~/site/pages/cart/common'
export default class extends Controller {
  static targets = ['currencyCodeField', 'currencyTypeField', 'creditIdField']

  changeCurrency({ params: { currencyType, currencyCode, creditId } }) {
    this.currencyTypeFieldTarget.value = currencyType
    if (currencyCode) {
      this.currencyCodeFieldTarget.value = currencyCode
    } else if (creditId) {
      this.creditIdFieldTarget.value = creditId
    }
    updateCartAndPrices()
  }

  changeCurrencyFromSelect(event) {
    this.changeCurrency({ params: event.target.selectedOptions[0].dataset })
  }
}
